// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"95dd9295","453":"3c894580","455":"58f88a71"}[chunkId] + ".chunk.js";
};